// extracted by mini-css-extract-plugin
module.exports = {"tabContainer":"tabs_tabContainer__31oky","tab":"tabs_tab__3Z-VX","selectedTab":"tabs_selectedTab__aCdpg"};